import React, { useMemo } from "react";
import { Outlet } from "react-router-dom";
import { PeekGrid, PeekContainer, PeekChip, PeekStack, PeekTypography, useTheme, keyframes, styled, } from "@piiqtechnologies/ui-components";
import { RefetchProvider } from "@piiqtechnologies/ui-lib";
import SideBarMenu from "@components/side-navbar";
import SwitchUser from "@layouts/auth/SwitchUser";
import { useAuthContext } from "@stores/AuthContext";
import { AlertOctagon } from "@piiqtechnologies/svg-icons";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
const ChipAnimation = keyframes `
  0% {
    box-shadow: none;
    outline-offset: 0;
  }
  100% {
    outline-color: rgba(255, 255, 255, 0);
    outline-offset: 10px;
  }
`;
const AnimatedChip = styled(PeekChip)(({ theme }) => ({
    zIndex: 10000,
    position: "absolute",
    top: "20px",
    left: "45vw",
    margin: "auto",
    outline: "1px solid",
    outlineColor: theme.palette.error.main,
    outlineOffset: 0,
    animation: `${ChipAnimation} 2s cubic-bezier(0.19, 1, 0.22, 1) infinite`,
}));
const DevEnvironmentAlert = () => {
    const intl = useIntl();
    const theme = useTheme();
    return (React.createElement(AnimatedChip, { color: "error", label: React.createElement(PeekStack, { direction: "row", gap: 1, alignItems: "center" },
            React.createElement(AlertOctagon, { fontSize: 20 }),
            React.createElement(PeekTypography, { variant: "h3", fontWeight: theme.typography.fontWeightLight }, intl.formatMessage(messages.dashboardDevEnvironment))) }));
};
export const DashboardLayout = () => {
    const { proxyUser } = useAuthContext();
    const isDevEnvironment = useMemo(() => process.env.PEEK_APP_ENVIRONMENT === "dev", []);
    return (React.createElement(PeekContainer, { maxWidth: "xl" },
        React.createElement(SideBarMenu, null),
        React.createElement(PeekGrid, { container: true, pl: 7, pr: 0, py: 2, rowSpacing: 4, direction: "column" },
            proxyUser && (React.createElement(PeekGrid, { item: true, xs: 12 },
                React.createElement(SwitchUser, null))),
            isDevEnvironment && React.createElement(DevEnvironmentAlert, null),
            React.createElement(RefetchProvider, null,
                React.createElement(Outlet, null)))));
};
export default DashboardLayout;
